import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 9h7a3 3 0 0 1 0 6h-4l2 -2","key":"svg-0"}],["path",{"d":"M12 17l-2 -2","key":"svg-1"}],["path",{"d":"M3 3v18","key":"svg-2"}],["path",{"d":"M21 3v18","key":"svg-3"}]]

const IconTextWrapColumn = createReactComponent('outline', 'text-wrap-column', 'TextWrapColumn', __iconNode);

export default IconTextWrapColumn;